import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { fetchUnknownDishTypes } from "slices/dishesSlice";
import type { LocalDishType } from "types/mainTypes";
import { useAppDispatch } from "./utilsHooks/storeHooks";

export const useFetchUnknownDishTypes = () => {
	const apolloClient = useApolloClient();
	const dispatch = useAppDispatch();

	const getUnknownDishTypes = useCallback(
		(orderDishTypes: LocalDishType[]) =>
			dispatch(
				fetchUnknownDishTypes({
					orderDishTypes: orderDishTypes,
					apolloClient: apolloClient,
				}),
			),
		[dispatch, apolloClient],
	);

	return { getUnknownDishTypes: getUnknownDishTypes };
};
